import { useState, useEffect } from 'react'
import { fetchBlockData, BlockData } from 'data/blockPayments'

export function useBlockData(gigId?: number) {
  const [data, setData] = useState<BlockData | null>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!gigId) return

    setIsLoading(true)
    fetchBlockData(gigId)
      .then(setData)
      .catch((err) => {
        if (err.message === 'No block payment data found') {
          setData(null)
        } else {
          setError(err.message)
        }
      })
      .finally(() => setIsLoading(false))
  }, [gigId])

  return { data, isLoading, error }
}
